export default __webpack_public_path__ + "static/media/5356.22af3615.png";